"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const hooks_1 = require("hooks");
const WizardFooter_1 = __importDefault(require("./WizardFooter"));
const WizardHeader_1 = __importDefault(require("./WizardHeader"));
function WizardLayout({ children }) {
    (0, hooks_1.useNetworkErrorReporter)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(WizardHeader_1.default, {}), children, (0, jsx_runtime_1.jsx)(WizardFooter_1.default, {})] }));
}
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps))(WizardLayout);
